import { render, staticRenderFns } from "./CMCourseConfiguration.vue?vue&type=template&id=6c019cbc&lang=pug"
import script from "./CMCourseConfiguration.vue?vue&type=script&lang=js"
export * from "./CMCourseConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports